import React, { forwardRef } from 'react';
import './Input.css';

const Input = forwardRef((props, ref) => {
    const _onAddClick = () => {
        // console.log(ref.current.value);
        props.addInput(ref.current.value); //將 value 傳入父元件的 addInput
    }

    let Inital_input = null;
    if(props.input.length !== 0){
        Inital_input = props.input[0].input;
    }

    return(
        <div>
            <textarea 
                rows="12" 
                ref={ref}
                defaultValue={Inital_input}
                placeholder="Enter one or more OLS BBCodes or Parcel IDs or Tracking Numbers (press ENTER to separate each number)"
            />
            <br /><br />
            <div className="search_button" onClick={_onAddClick}>Search</div>
        </div>
    )
});

export default Input ;